import React from "react";
import { FiLock } from "react-icons/fi";
import { logo } from "../assets/images";

/**
 * Subtle trust seal shown on customer-facing link pages (payment links, business
 * pages, deposit, success) so the person paying knows the page is powered by
 * Deexoptions. Kept intentionally small so it never competes with the merchant's
 * own branding.
 *
 * NOTE: `logo.svg`'s wordmark is filled white, so the pill MUST stay dark for it
 * to be legible — do not switch this to a light background.
 */
const PoweredByDeex = ({
  label = "Powered by",
  // Spacing lives in the default rather than the base classes so a caller can
  // replace it outright — `py-8` and a caller's `pb-8` would otherwise collide.
  className = "py-8",
}: {
  label?: string;
  className?: string;
}) => {
  return (
    <div className={`flex w-full justify-center ${className}`}>
      <a
        href="https://deexoptions.onelink.me/m2Ah/hulev7c1"
        target="_blank"
        rel="noopener noreferrer"
        className="group inline-flex items-center gap-2 rounded-full bg-gray-900 px-3.5 py-2 shadow-sm ring-1 ring-black/5 transition-all duration-200 hover:-translate-y-px hover:bg-black hover:shadow-md"
      >
        <FiLock className="text-[12px] text-gray-400 transition-colors group-hover:text-white" />
        <span className="text-[10px] font-semibold uppercase tracking-[0.09em] text-gray-400 transition-colors group-hover:text-gray-300">
          {label}
        </span>
        <span className="h-3.5 w-px bg-white/15" />
        <img src={logo} alt="Deexoptions" className="h-[14px] w-auto" />
      </a>
    </div>
  );
};

export default PoweredByDeex;
